import { createSelector } from 'reacticoon/selector'

import { getJwtToken, getSession as getSessionFromStorage } from './config'

export const getSession = createSelector([getJwtToken, getSessionFromStorage], (jwtToken, session) => ({
  ...session,
  jwtToken,
  isLoggedIn: !!jwtToken,
}))
